module.exports = __webpack_public_path__ + "static/img/HR@2x.e947026f.jpg";